import * as React from "react";
import jQuery from "jquery";

import { Selector } from "../../components/molecules/selector-group/selector";

interface IProps {
  defaultScrollText?: string;
  iconElement?: JSX.Element;
  isItemsLoading?: boolean;
  isTyped?: boolean;
  itemKey?: string;
  itemName?: string;
  items: (object | string)[];
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
  onClick?(): void;
  onClose?(): void;
  onSelect(item: object | string): void;
  trackChange?(value: string | undefined): void;
  placeholder: string;
  selectedItem?: string;
  disabledItems?: string[];
  isDisabled?: boolean;
  children?: React.ReactNode;
}

interface IState {
  active: boolean;
}

class SelectorContainer extends React.Component<IProps, IState> {
  private readonly timeoutDelay = 150;
  private readonly inputRef = React.createRef<HTMLInputElement>();
  private readonly listRef = React.createRef<HTMLElement>();
  private suggestionTimer!: number;

  public state: IState = {
    active: false,
  };

  public componentDidMount(): void {
    if (this.inputRef.current) {
      if (this.props.selectedItem) {
        this.inputRef.current.value = this.props.selectedItem;
      }
    }
  }

  public componentDidUpdate(prevProps: IProps) {
    if (
      this.inputRef.current &&
      prevProps.selectedItem !== this.props.selectedItem &&
      !this.props.selectedItem
    ) {
      this.inputRef.current.value = "";
    }

    if (
      this.inputRef.current &&
      prevProps.selectedItem !== this.props.selectedItem &&
      this.props.selectedItem
    ) {
      this.inputRef.current.value = this.props.selectedItem;
    }
  }

  public componentWillUnmount(): void {
    window.clearTimeout(this.suggestionTimer);
  }

  public toggleSelector = () => {
    const active = !this.state.active;

    this.setState({ active }, () => {
      if (
        active &&
        this.props.selectedItem &&
        this.listRef.current &&
        jQuery(this.listRef.current).find(".highlighted").length
      ) {
        const setOffsetTop = jQuery(this.listRef.current).find(
          ".highlighted",
        )[0].offsetTop;
        this.listRef.current.scrollTop = setOffsetTop;
      } else if (
        active &&
        !this.props.selectedItem &&
        this.props.defaultScrollText &&
        this.listRef.current &&
        jQuery(this.listRef.current).find(".default").length
      ) {
        const setOffsetTop = jQuery(this.listRef.current).find(".default")[0]
          .offsetTop;
        this.listRef.current.scrollTop = setOffsetTop;
      }
    });

    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  public closeSelector = () => {
    const active = false;

    this.suggestionTimer = window.setTimeout(() => {
      this.setState({ active });
      this.props.trackChange?.(this.props.selectedItem);

      if (this.props.onClose) {
        this.props.onClose();
      }
    }, this.timeoutDelay);
  };

  /**
   * Render Selector
   */
  public render() {
    return (
      <Selector
        active={this.state.active}
        defaultScrollText={this.props.defaultScrollText}
        iconElement={this.props.iconElement}
        inputRef={this.inputRef}
        isItemsLoading={this.props.isItemsLoading}
        isTyped={this.props.isTyped}
        isDisabled={this.props.isDisabled}
        itemKey={this.props.itemKey}
        itemName={this.props.itemName}
        items={this.props.items}
        disabledItems={this.props.disabledItems ? this.props.disabledItems : []}
        listRef={this.listRef}
        onBlur={this.closeSelector}
        onChange={this.props.onChange}
        onClick={this.toggleSelector}
        onFocus={this.toggleSelector}
        onSelect={this.props.onSelect}
        placeholder={this.props.placeholder}
        selectedText={this.props.selectedItem}
      >
        {this.props.children}
      </Selector>
    );
  }
}

export { SelectorContainer };
